$(function() {

  let formRegister = $('#form-register');
  let boxData = formRegister.find('.data');
  let boxRegister = formRegister.find('.box-register');

  $('.btn-continuar').on('click', function(e){
    e.preventDefault();

    let isValid = formRegister.valid();

    if (isValid) {
      boxData.hide();
      boxRegister.fadeIn();
    }

    // if ($('#terms').is(':checked')) {

    //   boxData.hide();
    //   boxRegister.fadeIn();

    // } else {
    //   $('#terms').parent().addClass('error');
    // }
  });

  $(".iptText").keydown(function (e) {
    var a = e.key;
    // if (a.length == 1) return /[a-z]|\$|#|\*/i.test(a);
    if (a.length == 1) return /^[a-zA-Z\s ñáéíóúÑÁÉÍÓÚ]+$/i.test(a);
    return true;
  });

  $(".iptNumber").keydown(function (e) {
    var a = e.key;
    if (a.length == 1) return /[0-9]|\+|-/.test(a);
    return true;
  });

  $.validator.addMethod("emailonly", function (value, element) {
    return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(value);
  }, "Ingrese email valido");

  formRegister.validate({
    errorPlacement: function errorPlacement(error, element) {
      element.before(error);
    },
    rules: {
      email: {
        required: true,
        email: true,
        emailonly: true
      }
    },
    highlight: function (element) {
      var el = $(element);
      el.parent().addClass('error');
    },
    unhighlight: function (element) {
      var el = $(element);
      el.parent().removeClass('error');
    },
    errorPlacement: function (error, element) {}
  });

});
